// The API caps pages at 200. Refresh every loaded page instead of silently
// replacing a larger board with only the first capped response.
export async function fetchActivityWindow(fetchPage, { limit, offset = 0, includeTotals = true, ...options }) {
  const activities = [];
  let result;
  let totals;
  let nextOffset = offset;
  do {
    if (options.signal?.aborted) throw new DOMException("Activity request cancelled", "AbortError");
    result = await fetchPage({ ...options, limit: Math.min(200, limit - activities.length), offset: nextOffset, includeTotals: includeTotals && activities.length === 0 });
    const rows = Array.isArray(result.data.activities) ? result.data.activities : [];
    if (result.data.totals) totals = result.data.totals;
    activities.push(...rows);
    nextOffset += rows.length;
    if (!rows.length || !result.data.hasMore) break;
  } while (activities.length < limit);
  return { ...result, data: { ...result.data, activities, nextOffset, ...(totals ? { totals } : {}) } };
}
